import { Component, OnInit, Input } from '@angular/core';
import { FormArray, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AssessmentService, SuperUserService } from 'src/app/_services/generatedServices';
import { ToasterService } from 'src/app/_services/toaster.service';
import { CourseViewModel, CreateAssessmentViewModel, AssessmentViewModel } from 'src/app/_models/generatedModels';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Enumerable from 'linq';
import { AuthenticationService } from 'src/app/_services/authentication.service';

@Component({
  selector: 'bxl-add-edit-assessment-modal',
  templateUrl: 'add-edit-assessment-modal.component.html',
})
export class AddEditAssessmentModalComponent implements OnInit {
  initialized = false;
  questions: FormArray;
  answers: FormArray;
  submitComplete: Promise<{}> | undefined;
  submitComplete2: Promise<{}> | undefined;
  public formGroup: FormGroup;
  @Input() courseEventId: number;
  errorMessage = '';

  assessment: CreateAssessmentViewModel;

  constructor(private superUser: SuperUserService, private assessmentService: AssessmentService, public auth: AuthenticationService, private activeModal: NgbActiveModal, private toastr: ToasterService, private fb: FormBuilder) {}

  ngOnInit(): void {
    this.superUser.getAssessment(this.courseEventId).subscribe((result) => {
      this.assessment = result;

      if (this.assessment == null) {
        this.assessment = new CreateAssessmentViewModel();
      }
      this.setupForm();
    });
  }

  setupForm(): any {
    this.formGroup = this.fb.group({
      questions: this.fb.array([]),
    });

    this.loadQuestions();
    this.initialized = true;
  }

  loadQuestions() {
    this.questions = this.formGroup.get('questions') as FormArray;

    if (!this.assessment.questions || this.assessment.questions.length === 0) {
      this.questions.push(this.createQuestion());
      this.questions.push(this.createQuestion());
      this.questions.push(this.createQuestion());
      return;
    }

    this.assessment.questions.forEach((question) => {
      let answers = question.answers.map((x) => this.fb.group({ text: [x.text, [Validators.required]], isCorrectResponse: x.isCorrectResponse }));
      console.log(answers);
      this.questions.push(
        this.fb.group({
          text: [question.text, [Validators.required]],
          answers: this.fb.array(answers),
        })
      );
    });
  }

  ghostWrite() {
    this.errorMessage = '';
    this.submitComplete2 = new Promise((resetButton: any, reject) => {
      this.assessmentService.ghostWriteAssessment(this.courseEventId, 1).subscribe((result) => {
        this.formGroup = this.fb.group({
          questions: this.fb.array([]),
        });

        this.questions = this.formGroup.get('questions') as FormArray;

        var questions = Enumerable.from(result).forEach((x) => {
          let answers = x.answers.map((x) => this.fb.group({ text: [x.answerText, [Validators.required]], isCorrectResponse: x.isCorrect }));
          this.questions.push(
            this.fb.group({
              text: [x.questionText, [Validators.required]],
              answers: this.fb.array(answers),
            })
          );
        });

        resetButton();
      }, (error) => {
        this.errorMessage = error.error;
        resetButton();
      });
    });
  }

  public onSave() {
    this.errorMessage = '';

    if (!this.formGroup.valid) {
      this.formGroup.markAllControlsDirty();
      this.toastr.error('Please fill out all required fields', 'Error');
      return;
    }

    const formData: CreateAssessmentViewModel = Object.assign({}, this.assessment, this.formGroup.value);

    var error = false;
    Enumerable.from(formData.questions).forEach((q) => {
      if (Enumerable.from(q.answers).count((x) => x.isCorrectResponse) != 1) {
        this.errorMessage = 'Each question must have exactly one answer. Click the box to denote the answer';
        error = true;
        return;
      }
    });

    if (error) {
      return;
    }

    this.submitComplete = new Promise((resetButton: any, reject) => {
      console.log(this.formGroup.value);
      console.log(formData);

      if (this.assessment.id != null) {
        this.update(formData, resetButton);
      } else {
        this.save(formData, resetButton);
      }
    });
  }

  save(formData: CreateAssessmentViewModel, resetButton: () => any) {
    this.superUser.createAssessment(this.courseEventId, formData).subscribe(
      (job) => {
        this.activeModal.dismiss();
        this.toastr.success('Assessment Saved', 'Success');
        resetButton();
      },
      (error) => resetButton()
    );
  }

  update(formData: CreateAssessmentViewModel, resetButton: () => any) {
    this.superUser.updateAssessment(this.courseEventId, this.assessment.id, formData).subscribe(
      (job) => {
        this.activeModal.dismiss();
        this.toastr.success('Assessment Updated', 'Success');
        resetButton();
      },
      (error) => resetButton()
    );
  }

  createQuestion(): FormGroup {
    return this.fb.group({
      text: ['', [Validators.required]],
      answers: this.fb.array([this.createAnswer(), this.createAnswer(), this.createAnswer(), this.createAnswer()]),
    });
  }

  createAnswer(): FormGroup {
    return this.fb.group({
      text: ['', [Validators.required]],
      isCorrectResponse: false,
    });
  }

  addQuestion(): void {
    this.questions = this.formGroup.get('questions') as FormArray;
    this.questions.push(this.createQuestion());
  }

  removeQuestion(index: number): void {
    this.questions = this.formGroup.get('questions') as FormArray;
    this.questions.removeAt(index);
  }

  addAnswer(question: FormGroup): void {
    this.answers = question.get('answers') as FormArray;
    this.answers.push(this.createAnswer());
  }

  onCancel() {
    this.activeModal.dismiss();
  }

  removeAnswer(question: FormGroup, index: number): void {
    this.answers = question.get('answers') as FormArray;
    //this.answers.push(this.createAnswer());

    //this.questions = this.formGroup.get('questions') as FormArray;
    this.answers.removeAt(index);
  }
}
